import { createSelector } from "reselect";
import _ from "lodash";
const createSelectors = parentReducer => {
    return new (class {
        selectUsers = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerTableDataWidget_reducer"];
            return reducer.users;
        };
        selectPage = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerTableDataWidget_reducer"];
            return reducer.page;
        };
        selectRow = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerTableDataWidget_reducer"];
            return reducer.row;
        };
        selectTableConfig = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerTableDataWidget_reducer"];
            return reducer.tableConfig;
        };
        selectUserInfo = createSelector(
            [this.selectUsers, this.selectTableConfig],
            (users = false, tableConfig = false) => {
                if (users && tableConfig) {
                    let userProfiles = _.compact(
                        Object.keys(users).map(uid => {
                            let profile = _.get(users[uid], "profile") || false;
                            let deleted =
                                _.get(users[uid], "profile.deleted") || false;
                            if (!deleted && profile) {
                                let fname =
                                    _.get(profile, "first_name") || "N/A";
                                let lname =
                                    _.get(profile, "last_name") || "N/A";

                                let requiredKeysFromProfile = getRequiredKeysFromProfile(
                                    tableConfig,
                                    profile
                                );

                                return {
                                    ...requiredKeysFromProfile,
                                    user_name: `${fname} ${lname}`,
                                    uid
                                };
                            } else return false;
                        })
                    );

                    return _.orderBy(userProfiles, "user_name", "asc");
                } else return false;
            }
        );
    })();
};

const getRequiredKeysFromProfile = (tableConfig, profile) => {
    return tableConfig.reduce((acc, curr) => {
        acc[curr.key] = _.get(profile, `${curr.key}`) || "N/A";
        return acc;
    }, {});
};
export default createSelectors;
